module.exports = __webpack_public_path__ + "static/media/thumbs-up.bebbf786.png";